/**
 * Tracks the most recently visited episode UUID in localStorage so the admin
 * panel and landing page can offer a "back to your episode" shortcut even
 * after a hard reload.
 */

const KEY = 'studio-v2.last-episode';

export function rememberEpisode(uuid: string | null): void {
  if (typeof window === 'undefined') return;
  if (!uuid) {
    localStorage.removeItem(KEY);
    return;
  }
  try {
    localStorage.setItem(KEY, uuid);
  } catch {
    // storage full / disabled — ignore, this is best-effort.
  }
}

export function getLastEpisode(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}
